/* THIS IS FILE IS AUTO-GENERATED BY graphql-codegen. DO NOT EDIT THIS FILE DIRECTLY! */
/* eslint-disable eslint-comments/no-unlimited-disable */
/* eslint-disable */
import * as Types from "../../types/definitions/vendor/graphql-schema.d";
import { DocumentNode } from "graphql";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type UpdateBoughtItemFeedbackMutationVariables = Types.Exact<{
  input: Types.KeptItemClientFeedbackUpdateInput;
}>;
export type UpdateBoughtItemFeedbackMutation = {
  __typename?: "Mutation";
  keptItemClientFeedbackUpdate?: {
    __typename?: "KeptItemClientFeedbackUpdatePayload";
    result: {
      __typename?: "KeptItemClientFeedbackUpdateResult";
      skuId: string;
    };
  } | null;
};
export const UpdateBoughtItemFeedbackDocument = {
  kind: "Document",
  definitions: [{
    kind: "OperationDefinition",
    operation: "mutation",
    name: {
      kind: "Name",
      value: "updateBoughtItemFeedback"
    },
    variableDefinitions: [{
      kind: "VariableDefinition",
      variable: {
        kind: "Variable",
        name: {
          kind: "Name",
          value: "input"
        }
      },
      type: {
        kind: "NonNullType",
        type: {
          kind: "NamedType",
          name: {
            kind: "Name",
            value: "KeptItemClientFeedbackUpdateInput"
          }
        }
      }
    }],
    selectionSet: {
      kind: "SelectionSet",
      selections: [{
        kind: "Field",
        name: {
          kind: "Name",
          value: "keptItemClientFeedbackUpdate"
        },
        arguments: [{
          kind: "Argument",
          name: {
            kind: "Name",
            value: "input"
          },
          value: {
            kind: "Variable",
            name: {
              kind: "Name",
              value: "input"
            }
          }
        }],
        selectionSet: {
          kind: "SelectionSet",
          selections: [{
            kind: "Field",
            name: {
              kind: "Name",
              value: "result"
            },
            selectionSet: {
              kind: "SelectionSet",
              selections: [{
                kind: "Field",
                name: {
                  kind: "Name",
                  value: "skuId"
                }
              }]
            }
          }]
        }
      }]
    }
  }]
} as unknown as DocumentNode;
export type UpdateBoughtItemFeedbackMutationFn = Apollo.MutationFunction<UpdateBoughtItemFeedbackMutation, UpdateBoughtItemFeedbackMutationVariables>;

/**
 * __useUpdateBoughtItemFeedbackMutation__
 *
 * To run a mutation, you first call `useUpdateBoughtItemFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBoughtItemFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBoughtItemFeedbackMutation, { data, loading, error }] = useUpdateBoughtItemFeedbackMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBoughtItemFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBoughtItemFeedbackMutation, UpdateBoughtItemFeedbackMutationVariables>) {
  const options = {
    ...defaultOptions,
    ...baseOptions
  };
  return Apollo.useMutation<UpdateBoughtItemFeedbackMutation, UpdateBoughtItemFeedbackMutationVariables>(UpdateBoughtItemFeedbackDocument, options);
}
export type UpdateBoughtItemFeedbackMutationHookResult = ReturnType<typeof useUpdateBoughtItemFeedbackMutation>;
export type UpdateBoughtItemFeedbackMutationResult = Apollo.MutationResult<UpdateBoughtItemFeedbackMutation>;
export type UpdateBoughtItemFeedbackMutationOptions = Apollo.BaseMutationOptions<UpdateBoughtItemFeedbackMutation, UpdateBoughtItemFeedbackMutationVariables>;